import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "linear-background card",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { class: "card-body p-0 d-flex justify-content-between flex-column overflow-hidden" }
const _hoisted_3 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "Users")
], -1)
const _hoisted_5 = { class: "ms-1" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-4" }, null, -1)
const _hoisted_8 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "Individual Users")
], -1)
const _hoisted_10 = { class: "d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder text-gray-800 d-block fs-3" }, "Business Users")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_UsersFilterWidgets = _resolveComponent("UsersFilterWidgets")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([_ctx.widgetClasses, "card"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", `text-${_ctx.chartColor}`])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    style: {"background-color":"#2196f3"},
                    class: _normalizeClass([`btn-active-color-${_ctx.chartColor}`, "btn btn-sm btn-icon btn-color-white btn-active-white border-0 me-n3"]),
                    "data-kt-menu-trigger": "click",
                    "data-kt-menu-placement": "bottom-end",
                    "data-kt-menu-flip": "top-end"
                  }, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
                    ])
                  ], 2),
                  _createVNode(_component_UsersFilterWidgets, {
                    onFilterSelected: _ctx.onTypeChange,
                    onReset: _ctx.onReset
                  }, null, 8, ["onFilterSelected", "onReset"])
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.data.data.total), 1)
              ], 2)
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", `text-${_ctx.chartColor}`])
              }, _toDisplayString(_ctx.data.data.individualUsers), 3)
            ]),
            _createVNode(_component_apexchart, {
              class: "mixed-widget-10-chart",
              options: _ctx.chartOptions,
              series: _ctx.series,
              type: "bar",
              height: _ctx.chartHeight
            }, null, 8, ["options", "series", "height"]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", {
                class: _normalizeClass(["fw-bolder fs-3", `text-${_ctx.chartColor}`])
              }, _toDisplayString(_ctx.data.data.businesUsers), 3)
            ]),
            _createVNode(_component_apexchart, {
              class: "mixed-widget-10-chart",
              options: _ctx.chartOptions1,
              series: _ctx.series1,
              type: "bar",
              height: _ctx.chartHeight
            }, null, 8, ["options", "series", "height"])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}